import { ApiBaseService } from 'eightcap-core/api/crud.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const configPath = 'config_';
@Injectable()
export class ConfigService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/application/store');
    }

    getCompanyGroupInfo(id: string): Observable<any> {
        return this.httpClient
            .get(`${this.basePath}/${configPath}${id}`)
            .pipe(map((res: any) => res && JSON.parse(res)));
    }

    saveConfig(id: string, configContent: any): Observable<any> {
        return this.httpClient.post(
            `${this.basePath}/${configPath}${id}`,
            JSON.parse(configContent)
        );
    }

    isValidJson(inputJson: any): boolean {
        try {
            //check if the string exists
            if (inputJson) {
                const obj = JSON.parse(inputJson);
                if (obj && obj.constructor === Object) {
                    return true;
                }
            }
        } catch (e: any) {}
        return false;
    }
}
